const FAVICON_REL = 'shortcut icon';
const FAVICON_TYPE = 'image/x-icon';

export default function applyFavicon(favIconUrl: string) {
    if (!document) {
        // We may be in SSR? Bail either way
        return;
    }

    let favIconElement = document.querySelector(`link[rel="${FAVICON_REL}"]`) as HTMLLinkElement;

    if (!favIconElement) {
        favIconElement = document.createElement('link');
        favIconElement.rel = FAVICON_REL;
        favIconElement.type = FAVICON_TYPE;

        document.head.appendChild(favIconElement);
    }

    favIconElement.href = favIconUrl;
}
